"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var data_model_1 = require("@rdfjs/data-model");

var asynciterator_1 = require("asynciterator");

var rdf_string_1 = require("rdf-string");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * An abstract actor that handles Path operations.
 *
 * Provides multiple helper functions used by the Path operation actors.
 */


var ActorAbstractPath =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorAbstractPath, _bus_query_operation_);

  function ActorAbstractPath(args, predicateType) {
    var _this;

    _classCallCheck(this, ActorAbstractPath);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorAbstractPath).call(this, args, 'path'));
    _this.predicateType = predicateType;
    return _this;
  }

  _createClass(ActorAbstractPath, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(pattern.predicate.type !== this.predicateType)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This Actor only supports ' + this.predicateType + ' Path operations.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }() // generates a blank node that does not yet occur in the path

  }, {
    key: "generateBlankNode",
    value: function generateBlankNode(path, name) {
      if (!name) {
        return this.generateBlankNode(path, 'b');
      } // path predicates can't contain variables/blank nodes


      if (path && (path.subject.value === name || path.object.value === name)) {
        return this.generateBlankNode(path, name + 'b');
      }

      return data_model_1.blankNode(name);
    } // based on definition in spec https://www.w3.org/TR/sparql11-query/
    // returns all nodes visited by infinitely repeating the given predicate, starting from x

  }, {
    key: "ALPeval",
    value: function () {
      var _ALPeval = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(x, predicate, context) {
        var it;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                it = new asynciterator_1.BufferedIterator();
                _context2.next = 3;
                return this.ALP(x, predicate, context, {}, it, {
                  count: 0
                });

              case 3:
                return _context2.abrupt("return", it);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function ALPeval(_x3, _x4, _x5) {
        return _ALPeval.apply(this, arguments);
      }

      return ALPeval;
    }()
  }, {
    key: "ALP",
    value: function () {
      var _ALP = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(x, predicate, context, V, it, counter) {
        var _this2 = this;

        var s, b, bString, path, results;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                s = rdf_string_1.termToString(x);

                if (!V[s]) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                it._push(x);

                V[s] = x;
                b = this.generateBlankNode();
                bString = rdf_string_1.termToString(b);
                path = ActorAbstractPath.FACTORY.createPath(x, predicate, b);
                _context4.t0 = bus_query_operation_1.ActorQueryOperation;
                _context4.next = 11;
                return this.mediatorQueryOperation.mediate({
                  operation: path,
                  context: context
                });

              case 11:
                _context4.t1 = _context4.sent;
                results = _context4.t0.getSafeBindings.call(_context4.t0, _context4.t1);
                counter.count++;
                results.bindingsStream.on('data',
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee3(bindings) {
                    var result;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            result = bindings.get(bString);
                            _context3.next = 3;
                            return _this2.ALP(result, predicate, context, V, it, counter);

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x12) {
                    return _ref.apply(this, arguments);
                  };
                }());
                results.bindingsStream.on('end', function () {
                  if (--counter.count === 0) {
                    it.close();
                  }
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function ALP(_x6, _x7, _x8, _x9, _x10, _x11) {
        return _ALP.apply(this, arguments);
      }

      return ALP;
    }()
  }]);

  return ActorAbstractPath;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

ActorAbstractPath.FACTORY = new sparqlalgebrajs_1.Factory();
exports.ActorAbstractPath = ActorAbstractPath;